import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  gap: ${(props) => props.theme.spacing.lg};

  .loading {
    &__spinner {
      width: 50px;
      height: 50px;
      border: 4px solid ${(props) => props.theme.colour.background.tertiary};
      border-top: 4px solid ${(props) => props.theme.colour.brand.primary};
      border-radius: 50%;
      animation: ${spin} 1s linear infinite;
    }

    &__text {
      font-size: ${(props) => props.theme.fonts.textFontSizeM};
      color: ${(props) => props.theme.colour.text.secondary};
      font-weight: ${(props) => props.theme.fonts.fontWeightMedium};
    }
  }

  /* Variante para pantalla completa */
  &.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: ${(props) => props.theme.colour.background.primary};
    z-index: ${(props) => props.theme.zIndex.modal};
  }

  /* Variante para contenedor */
  &.container {
    padding: ${(props) => props.theme.spacing.xl};
  }
`;

export default LoadingStyled;
